import { Component, OnInit,Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';

@Component({
  selector: 'app-manage',
  templateUrl: './manage.component.html',
  styleUrls: ['./manage.component.scss'],
})
export class ManageComponent implements OnInit {


  is_editing = false;
  tags: any = [];
  @Input() url = 'clients';
  @Input() title = '';

  roles: any = [];

  add_tag = {
    guid: '',
    title: '',
    colour: '#90ee90',
    description: ''
  }


  constructor(public modalController: ModalController, private apiService: ApiService, public globalService: GlobalService) { }

  ngOnInit() {
    this.GetData();
  }

  async GetData() {
    let data: any = await this.apiService.get(`tags/${this.url}`);
    this.tags = data.data;
    if(this.tags === null) return;
  }

  async Cancel() {
    this.modalController.dismiss(null);
  }

  async Create() {
    let data: any = await this.apiService.post(`tags/${this.url}`,this.add_tag);
    this.globalService.presentToastMessage(data.message,data.success);
    await this.GetData();
    this.CancelEdit();
  }

  async Update() {

    
  }
  async CancelEdit() {
    this.is_editing = false;
    this.add_tag = {
      guid: '',
      title: '',
      colour: '#90ee90',
      description: ''
    };
  }

  async EditTag(tag) {
    this.is_editing = true;
    this.add_tag = tag;

  }

  async DeleteTag(tag) {

    
  }

}
